import { useMutation } from '@apollo/client';
import { CREATE_CURRICULUM_MUTATION } from '../../mutations';

export function useCreateCurriculumMutation() {
    return useMutation( CREATE_CURRICULUM_MUTATION );
}
